import useAxios from "../../hooks/useAxios";

const usePrismPaymentService = () => {
  const axiosPayments = useAxios();
  const axiosCreatePayment = useAxios();
  const axiosUpdatePayment = useAxios();
  const axiosDeletePayment = useAxios();

  const getPayments = async () => {
    await axiosPayments.fetchData({
      url: "/prism/payments",
      method: "GET",
    });
  };

  const createPayment = async (data) => {
    return await axiosCreatePayment.fetchData({
      url: "/prism/payments",
      method: "POST",
      data,
    });
  };

  const updatePayment = async (id, data) => {
    return await axiosUpdatePayment.fetchData({
      url: `/prism/payments/${id}`,
      method: "PUT",
      data,
    });
  };

  const deletePayment = async (id) => {
    return await axiosDeletePayment.fetchData({
      url: `/prism/payments/${id}`,
      method: "DELETE",
    });
  };

  return {
    getPayments,
    paymentLoading: axiosPayments.loading,
    paymentResponse: axiosPayments.response,
    paymentError: axiosPayments.error,
    createPayment,
    createPaymentLoading: axiosCreatePayment.loading,
    createPaymentError: axiosCreatePayment.error,
    updatePayment,
    updatePaymentLoading: axiosUpdatePayment.loading,
    updatePaymentError: axiosUpdatePayment.error,
    deletePayment,
    deletePaymentLoading: axiosDeletePayment.loading,
    deletePaymentError: axiosDeletePayment.error,
  };
};

export default usePrismPaymentService;
